import { render, staticRenderFns } from "./ShippingCity.vue?vue&type=template&id=47f2597c&scoped=true"
import script from "./ShippingCity.vue?vue&type=script&lang=js"
export * from "./ShippingCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2597c",
  null
  
)

export default component.exports